import React from 'react';
import { Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import InstalledBaseTDAForm from '../../../InstalledBaseTDAForm';
import { FormStepProps } from '../../types';

const ServiceDataStep = ({ attributes, initialValues, formikRef }: FormStepProps) => {
    const { t } = useTranslation();

    if (attributes.length === 0) {
        return (
            <Typography level="body-md" sx={{ color: 'text.secondary' }}>
                {t('No service data attributes available')}
            </Typography>
        );
    }

    return (
        <InstalledBaseTDAForm
            attributes={attributes}
            initialFormValues={initialValues}
            setFormikHelpersRef={(ref) => { formikRef.current = ref; }}
            enableReinitialize={true}
        />
    );
};

export default ServiceDataStep;
